import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RESEND_COOLDOWN_SECONDS = 60;

export default function CheckEmailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { resendVerification } = useAuth();
  const [email, setEmail] = useState(location.state?.email || "");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    const prevTheme = document.body.getAttribute("data-theme");
    document.body.setAttribute("data-theme", "cobalt");
    return () => {
      if (prevTheme) document.body.setAttribute("data-theme", prevTheme);
      else document.body.removeAttribute("data-theme");
    };
  }, []);

  useEffect(() => {
    if (cooldown <= 0) return undefined;
    const timer = setInterval(() => {
      setCooldown((current) => (current > 0 ? current - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [cooldown]);

  const onResend = async () => {
    if (!email.trim()) {
      setError("Please enter your email address first");
      return;
    }
    setSending(true);
    setError("");
    setMessage("");
    const result = await resendVerification(email.trim());
    if (!result?.ok) {
      setError(result?.error || "Could not resend verification email");
      setSending(false);
      return;
    }
    setMessage(result?.message || "Verification email sent. Check your inbox.");
    setCooldown(RESEND_COOLDOWN_SECONDS);
    setSending(false);
  };

  return (
    <div className="auth-shell">
      <div className="auth-media" aria-hidden="true">
        <video className="auth-background-video" autoPlay muted loop playsInline>
          <source src="/backgroundvideo.mp4" type="video/mp4" />
        </video>
        <div className="auth-media-overlay" />
      </div>
      <div className="auth-card glass">
        <div className="brand-block">
          <img src="/wavvy-wordmark.png" alt="Wavvy" className="brand-wordmark" />
          <p>One last step before you join the chat.</p>
        </div>

        <h2 className="auth-panel-title centered">Check your email</h2>
        <p className="auth-helper">
          We sent a verification link to your inbox. Open it to activate your account.
        </p>

        <div className="auth-form">
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@wavvy.tn"
              required
            />
          </label>

          <button
            type="button"
            className="primary-btn"
            onClick={onResend}
            disabled={sending || cooldown > 0}
          >
            {sending ? "Sending..." : cooldown > 0 ? `Resend in ${cooldown}s` : "Resend verification email"}
          </button>

          <button type="button" className="ghost-btn" onClick={() => navigate("/auth/login")}>
            Back to Sign In
          </button>
        </div>

        {message ? <p className="auth-success-text">{message}</p> : null}
        {error ? <p className="error-text">{error}</p> : null}
      </div>
    </div>
  );
}
